import { gtm } from '@/core/analytics';

import type { SelfServiceSMBSignupStep } from '../types';

export type SelfServiceSMBSignupAnalyticsAction = 'view' | 'complete' | 'abandon';

interface TrackProps {
  trial_days?: number;
  billing_interval?: 'MONTH' | 'YEAR';
  reason?: string;
}

/**
 * Emit a self-service SMB signup funnel event to GTM. Mirrors the partner-
 * driven flow's `smbAnalytics.ts` wrapper but for the self-service entry
 * point. Allow-listed properties only — no PII (no email, password, OTP
 * token, payment details).
 *
 * Event name: `self_service_smb_signup_step_<action>`
 */
export function trackSelfServiceSMBSignupStep(
  action: SelfServiceSMBSignupAnalyticsAction,
  step: SelfServiceSMBSignupStep,
  props: TrackProps = {}
): void {
  gtm('event', `self_service_smb_signup_step_${action}`, {
    flow_kind: 'self_serve',
    step,
    ...props,
  });
}
